import * as d3 from 'd3'
export default {
  methods: {

     tbl_Router(selection, type, dataSet) {

      this.CRT.id++
      this.CRT.count++

      let itemGroup = selection
      .append('g')
      .attr('id', `LIST_${this.CRT.id}`)
      .attr('transform', `translate(0, ${this.CRT.count * 80})`)

      itemGroup
      .append('rect')
      .attr('id', `IFRAME_${this.CRT.id}`)
      .attr('x', 40).attr('y', 0).attr('rx', 5).attr('ry', 5).attr('width', 840).attr('height', 60)
      .attr('fill', '#fff').attr('stroke', '#E0E0DF').attr('stroke-width', .5).attr('fill-opacity', .1)

      itemGroup
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Del.svg`)
      .attr('x', 20).attr('y', 21).attr('width', 13).attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .5)} )
      .on('mouseout', function() { d3.select(this).transition().duration(250).style('opacity', 1)} )
      .on('click', ()=> { 
        this.del_Data(dataSet.SEQ) // -----> tbl_Action.js
      })

      if(type == 'Procedure') this.draw_Procedure(itemGroup, dataSet)
      else this.draw_Tables(itemGroup, dataSet)

      this.reflash(this.CRT) // #####
    },


    draw_Procedure(selection, dataSet) {
      
      this.gmx_Dropdown(selection, this.database, {id: `DATABASE_${this.CRT.id}`, label: 'Database',  boxWidth: 150, x: 200, y: 20})
      d3.select(`#ICON_TYPE_${this.CRT.id}`).attr('xlink:href', this.HOST + `/Database/icon/DB_${dataSet.TYPE}.svg`)

      let inputSet = [

        {id: `SEQ_${this.CRT.id}`,    label: 'Seq.',        x: -95, y: 20, width: 20,  maxLen: 1,  value: dataSet.SEQ, type: 'fixed'},
        {id: `TYPE_${this.CRT.id}`,   label: 'Type',        x: 55,  y: 20, width: 125, maxLen: 15, value: 'Procedure', type: 'fixed'},
        {id: `SCHEMA_${this.CRT.id}`, label: 'Schema Name', x: 365, y: 20, width: 180, maxLen: 18},
        {id: `NAME_${this.CRT.id}`,   label: 'Table Name',  x: 560, y: 20, width: 305, maxLen: 35},
      ]
      this.gmx_InputBox(selection, inputSet)

      for(let i=this.CRT.id; i>=0; i--){
        if(d3.select(`#LIST_${i}`)) d3.select(`#LIST_${i}`).moveToFront()
      }

    },


    draw_Tables(selection, dataSet) {
      
      this.gmx_Dropdown(selection, this.dataSource, {id: `TYPE_${this.CRT.id}`, label: 'Data Type', boxWidth: 110, x: 55, y: 20, icon: `TYPE_${this.CRT.id}`, type: ''})
      this.gmx_Dropdown(selection, this.database, {id: `DATABASE_${this.CRT.id}`, label: 'Database',  boxWidth: 165, x: 180, y: 20, type: ''})
      d3.select(`#FORM_TYPE_${this.CRT.id}`).text(dataSet.TYPE)
      d3.select(`#ICON_TYPE_${this.CRT.id}`).attr('xlink:href', this.HOST + `/Database/icon/DB_${dataSet.TYPE}.svg`)

      let inputSet = [
        {id: `SEQ_${this.CRT.id}`,    label: 'Seq.',        x: -35, y: 20,  width: 20, maxLen: 1, value: dataSet.SEQ, type: 'fixed'},
        {id: `SCHEMA_${this.CRT.id}`, label: 'Schema Name', x: 360, y: 20, width: 170, maxLen: 18, type: ''},

        {id: `FILE_PATH_${this.CRT.id}`,   label: 'File Path',  x: 180, y: 20, width: 290, maxLen: 90, type: ''},
        {id: `NAME_${this.CRT.id}`,        label: 'File Name',  x: 485, y: 20, width: 215, maxLen: 35, type: ''},
        {id: `EXCEL_SHEET_${this.CRT.id}`, label: 'Sheet Name', x: 715, y: 20, width: 150, maxLen: 25, type: ''},
      ]
      this.gmx_InputBox(selection, inputSet)

      for(let i=this.CRT.id; i>=0; i--){
        if(d3.select(`#LIST_${i}`)) d3.select(`#LIST_${i}`).moveToFront()
      }

      this.changeType(dataSet.TYPE, this.CRT.id)
    },


    changeType(type, id_) {

      d3.select(`#DROPDOWN_DATABASE_${id_}`).transition().duration(300).attr('visibility', type == 'Excel' ? 'hidden' : 'display')
      d3.select(`#INPUT_SCHEMA_${id_}`).transition().duration(300).attr('visibility', type == 'Excel' ? 'hidden' : 'display')
      
      d3.select(`#INPUT_NAME_${id_}`).transition().duration(300).attr('transform', type == 'Excel' ? `translate(485,20)` : `translate(545,20)`)
      d3.select(`#FOREIGN_NAME_${id_}`).transition().duration(300).attr('width', type == 'Excel' ? 215 : 320)
      d3.select(`#LABEL_NAME_${id_}`).text(type == 'Excel' ? 'File Name' : 'Table Name')

      d3.select(`#INPUT_SCHEMA_${id_}`).transition().duration(300).attr('visibility', type == 'Excel' ? 'hidden' : 'display')
      d3.select(`#INPUT_FILE_PATH_${id_}`).transition().duration(300).attr('visibility', type == 'Excel' ? 'display' : 'hidden')
      d3.select(`#INPUT_EXCEL_SHEET_${id_}`).transition().duration(300).attr('visibility', type == 'Excel' ? 'display' : 'hidden')

    },

  }
}